let pendingChatId: string | null = null;

export const setPendingOpenAttachments = (chatId: string): void => {
  pendingChatId = chatId;
};

export const consumePendingOpenAttachments = (chatId: string): boolean => {
  if (pendingChatId === chatId) {
    pendingChatId = null;
    return true;
  }
  return false;
};
